import axios from "axios";

export const actions = {
    getCustomerAudits(store, params) {
        const { additionalQueries, pageSize = 10, page = 1, sorts = null, filters = null } = params;

        let query = `page=${page}&pageSize=${pageSize}`;

        if (sorts) {
            query += `&${sorts}`;
        }
        if (filters) {
            query += `&${filters}`;
        }

        query = encodeURI(query);
        const url = `/customer-audits/${additionalQueries}/audits?${query}`;
        return axios.get(url);
    },
};
